import { Flex } from "@chakra-ui/react";
import IconAsButton from "src/components/IconAsButton";
import { ReactComponent as FullscreenIcon } from "./fullscreen.svg";

export default function Fullscreen({ onClick, status }) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      position="absolute"
      top="10px"
      left="16px"
      {...(status && status === "loading" && { pointerEvents: "none" })}
    >
      <IconAsButton
        icon={FullscreenIcon}
        size="20px"
        fill="white"
        onClick={onClick}
        maxHeight="28px"
        maxWidth="28px"
      />
    </Flex>
  );
}
